
import { Component, Vue, Prop, Emit } from "vue-property-decorator"

import vSelect from "vue-select"

import api from "@/services/api"
import { User } from "@/types"

	@Component({
		components: {
			"v-select": vSelect
		}
	})
export default class UserSelect extends Vue {
	@Prop({ required: true })
	public value!: string | null

	@Prop({ type: Boolean, default: false })
	showUserEmails!: boolean

	public searchUsers: User[] = []

	private selectedUser: User | null = null
	private debounceSearch: NodeJS.Timeout | null = null

	public mounted () {
		if (this.value) {
			api.userDetails(this.value).then(user => this.selectedUser = user)
		}
	}

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (this.debounceSearch) {
			clearTimeout(this.debounceSearch)
			this.debounceSearch = null
		}

		if (search === "") {
			this.searchUsers = []
		} else {
			loading(true)
			this.debounceSearch = setTimeout(async () => {
				try {
					this.searchUsers = await api.searchUsers(search)
				} finally {
					loading(false)
				}
			}, 500)
		}
	}

	public userPicture (user: User): string {
		if (user.pictureUrl) {
			return user.pictureUrl!
		} else {
			return api.pictureUrl(user.id)
		}
	}

	@Emit("input")
	public async addUser (user: User) {
		this.selectedUser = user
		return user ? user.id : null
	}

	public loadedImage (_result: any) {
		// do nothing here - this is just a handler to tell the browser not to show it until it's loaded
	}
}
